/**
 * Parsing sku list to show upfront in product shipment acc to limit
 * @param {object} data
 * @return {object} data
 */

const parseWidgetsData = (widgets) => {
    let widgetsData = {
        productShipments: [],
    }

    widgets?.forEach((widget) => {
        switch (widget.type) {
            case "order_placed": {
                const { title, icon, id, action_button, info, analytics_data } = widget.data
                widgetsData["orderPlaced"] = {
                    header: title,
                    image: {
                        url: icon,
                        alt: "",
                        width: 48,
                        height: 48,
                    },
                    animated: true,
                    internalData: {
                        internalSubHeader: `Order ID : ${id}${info ? "<br>" + info : ""}`,
                        internalHeader: "Your order has been placed!",
                        primaryCTA: {
                            label: "Continue exploring",
                            url: "/",
                        },
                        secondaryCTA: {
                            label: action_button?.text,
                            url: action_button?.details?.target_url,
                        },
                    },
                    analyticsData: analytics_data,
                }
                break
            }
            case "address_selection": {
                if (widget.data?.is_collapsed) {
                    widgetsData["addressSelectionCollapsed"] = {
                        icon: widget.data?.icon,
                        header: widget.data?.header,
                        addressName: widget.data?.address_name,
                        address: `${widget.data?.street1 ? widget.data?.street1 + ", " : ""}${
                            widget.data.street2 ? widget.data.street2 + ", " : ""
                        }${
                            widget.data.city && widget.data.street1
                                ? decodeURI(widget.data.city) + ", "
                                : decodeURI(widget.data.city)
                        }${widget.data.locality ? widget.data.locality + ", " : ""}${widget.data.state}${
                            widget.data.pincode ? " (" + widget.data.pincode + ")" : ""
                        }`,
                        ctaLabel: widget.data.cta?.text,
                        redirectUrl: widget.data.cta?.targetUrl,
                        functionMap: widget.data.cta?.action,
                    }
                } else {
                    widgetsData["addressSelectionExpanded"] = {
                        icon: widget.data?.icon,
                        header: widget.data?.header,
                        address: `${widget.data?.street1 ? widget.data?.street1 + ", " : ""}${
                            widget.data.street2 ? widget.data.street2 + ", " : ""
                        }${
                            widget.data.city && widget.data.street1
                                ? decodeURI(widget.data.city) + ", "
                                : decodeURI(widget.data.city)
                        }${widget.data.locality ? widget.data.locality + ", " : ""}${widget.data.state}${
                            widget.data.pincode ? " (" + widget.data.pincode + ")" : ""
                        }`,
                        number: widget.data?.contact_number,
                        name: widget.data?.name,
                        addressType: widget.data?.address_name,
                        ctaLabel: widget.data.cta?.text,
                        redirectUrl: widget.data.cta?.targetUrl,
                        functionMap: widget.data.cta?.action,
                    }
                }
                break
            }
            case "product_shipment": {
                widgetsData["productShipments"].push({
                    header: widget.data?.header,
                    subHeader: widget.data?.display_text,
                    subHeaderColor: "#208376",
                    icon: widget.data?.icon,
                    skus: getSkusOfProductShipment(widget.data.skus, 2),
                    ctaLabel: widget.data?.skus?.length > 2 ? widget.data?.list_expand_text : "",
                    hiddenSkus: getSkusOfProductShipment(widget.data.skus),
                    targetUrl: widget.data?.primary_cta?.target_url,
                    dialogData: {
                        icon: widget.data.dialog_data?.icon,
                        description: widget.data.dialog_data?.description,
                        label: widget.data.dialog_data?.confirm_cta?.text,
                    },
                })
                break
            }
            case "careplan_post_order": {
                if (widget.data.type === "care_plan_non_subscriber") {
                    widgetsData["carePlanNonSubscriber"] = {
                        time: widget.data?.data?.timer / 1000,
                        maxTime: widget.data?.data?.timer / 1000,
                        progressShow: widget.data?.data?.progress_show,
                        icon: widget.data?.data?.icon,
                        text: widget.data?.data?.text,
                        subText: widget.data?.data?.sub_text,
                        primaryCTA: {
                            label: widget.data?.data?.primary_cta?.text,
                            url: widget.data?.data?.primary_cta?.details?.target_url,
                        },
                        cpOfferExpired: {
                            text: widget.data.data.cp_offer_expired?.text,
                            subText: widget.data.data.cp_offer_expired?.sub_text,
                        },
                    }
                } else if (widget.data.type === "care_plan_subscriber") {
                    widgetsData["carePlanSubscriber"] = {
                        icon: widget.data?.data?.icon,
                        header: widget.data?.data?.text,
                        benefits: widget.data?.data?.benefits?.map((benefit) => ({
                            icon: benefit?.icon,
                            header: benefit?.text,
                            subHeader: benefit?.sub_text,
                            ctaLabel: benefit?.cta?.text,
                            url: benefit?.cta?.details?.target_url,
                        })),
                        secondaryCTA: {
                            label: widget.data?.data?.secondary_cta?.text,
                            url: widget.data?.data?.secondary_cta?.details?.target_url,
                        },
                    }
                }
                break
            }
            case "information_with_action": {
                widgetsData["informationWithAction"] = {
                    imageUrl: widget.data.image_url,
                    heading: widget.data.header,
                    ctaLabel: widget.data.cta?.text,
                    slug: widget.data.cta?.details?.target_url || widget.data.cta?.details?.web_target_url,
                }
                break
            }
            case "no_rx_upsell": {
                widgetsData["lowEmphasisUpsell"] = {
                    header: widget.data.header,
                    description: widget.data.display_text,
                    subHeader: widget.data.sub_header,
                    time: widget.data.time,
                    image: widget.data.image_url,
                }
                break
            }
            case "footnotes": {
                widgetsData["footnotes"] = {
                    data: [
                        {
                            header: "",
                            displayText: widget.data.display_text,
                        },
                    ],
                }
                break
            }
            case "quick_editable_details": {
                widgetsData["quickEditableDetails"] = {
                    header: widget.data?.header,
                    subHeading: widget.data?.sub_header,
                    details: widget.data?.details?.map((detail) => ({
                        imageUrl: detail.icon,
                        subText: detail.sub_text,
                        description: detail.display_text,
                        ctaLabel: detail.cta?.text,
                        ctaAction: detail.cta?.action,
                        targetUrl: detail.cta?.target_url,
                        isCtaEnabled: true,
                        errorText: detail.error_message,
                    })),
                    isLoading: false,
                    isTextHidden: false,
                    variantSmall: true,
                }
                break
            }
            case "labs_preparation": {
                widgetsData["labsPreparation"] = {
                    header: widget.data?.header,
                    subHeader: widget.data?.sub_header,
                    descriptionData: {
                        description: widget.data?.instructions,
                        color: null,
                        backgroundColor: widget.data?.background_color,
                    },
                }
                break
            }
            case "list_tests_cart": {
                const items = widget.data?.items ? widget.data?.items : widget?.data?.grouped_items[0]?.items
                widgetsData["listOfTestOnCart"] = {
                    showButton: false,
                    header: widget.data?.header,
                    subHeader: widget.data?.sub_header,
                    listOfItems: parsingListOfTestItems(items, widget.data?.up_front_count),
                    hiddenListOfTest: widget.data?.up_front_count
                        ? parseHiddenListOfTestItems(items, widget.data?.up_front_count)
                        : [],
                    linkText: widget.data?.cta?.text,
                    labItems: {
                        labId: widget.data?.lab?.id,
                        url: widget.data?.lab?.url,
                        imageUrl: widget.data?.lab?.image?.url,
                        altText: widget.data?.lab?.image?.alt,
                        header: widget.data?.lab?.header,
                        subHeader: widget.data?.lab?.sub_header,
                        ctaLabel: null,
                        changeLabsUrl: null,
                    },
                    footerData: {
                        label: widget.data?.footer?.label,
                        labIcon: widget.data?.footer?.lab_icon?.url,
                        labAltText: widget.data?.footer?.lab_icon?.alt,
                        infoIconData: {
                            infoIconUrl: widget.data?.footer?.info_icon?.url,
                            infoIconAlt: widget.data?.footer?.info_icon?.alt,
                        },
                    },
                    bottomSheetData: {
                        header: widget.data?.footer?.lab_details_bottomsheet?.heading,
                        ...parseBottomSheetData(widget.data?.footer?.lab_details_bottomsheet?.data),
                    },
                }
                break
            }
            case "status_timeline":
                {
                    widgetsData["statusTimeline"] = {
                        timelineStateData: widget.data?.states?.map((stateData = {}) => ({
                            icon: stateData.icon,
                            description: stateData.heading,
                            status: stateData.status,
                            subText: stateData.date,
                            steps: stateData.steps?.map((step = {}) => ({
                                status: step.status,
                                time: step.time,
                            })),
                        })),
                    }
                }
                break
            case "generic_message":
                {
                    widgetsData["genericMessage"] = widgetsData["genericMessage"]
                        ? widgetsData["genericMessage"]
                        : {
                              imageUrl: widget.data?.image,
                              header: widget.data?.header,
                              subHeader: widget.data?.sub_header,
                              cta: {
                                  action: widget.data?.cta?.action,
                                  text: widget.data?.cta?.text,
                                  details: {
                                      targetUrl: widget.data?.cta?.details?.target_url,
                                  },
                              },
                              icon: {
                                  url: widget.data?.icon,
                                  altText: "Generic message",
                              },
                          }
                }
                break
        }
    })
    return widgetsData
}

const parseFunnelSaleCompleteEventData = (data) => {
    if (!data) return null
    const { order_id = "", order_amount = "", order_items = [] } = data
    const orderItemsOS = order_items.reduce?.(
        (acc, item) => {
            acc.sku_id.push(String(item?.sku_id) || "")
            acc.product_prices.push(String(item?.base_price) || "0")
            acc.product_quantities.push(String(item?.sku_quantity) || "1")
            return acc
        },
        {
            sku_id: [],
            product_prices: [],
            product_quantities: [],
        }
    )

    return {
        orderId: order_id,
        sales: order_amount,
        id: orderItemsOS?.sku_id?.join("|"),
        mrp: orderItemsOS?.product_prices?.join("|"),
        quantity: orderItemsOS?.product_quantities?.join("|"),
        onlineSalesEvent: "funnel_salecomplete",
    }
}

/**
 * Parsing sku list to show upfront in product shipment acc to limit
 * @param {Array} skus
 * @param {Number} limit
 * @return {Array} skuList
 */
const getSkusOfProductShipment = (skus, limit) => {
    const skuList = []
    if (limit) {
        skus.forEach((sku, index) => {
            if (index < limit) {
                skuList.push({
                    header: sku.header,
                    imageUrl: sku.image,
                    skuId: sku.sku_id,
                    subHeader: sku.sub_header,
                })
            }
        })
    } else {
        skus.forEach((sku) => {
            skuList.push({
                header: sku.header,
                imageUrl: sku.image,
                skuId: sku.sku_id,
                subHeader: sku.sub_header,
            })
        })
    }

    return skuList
}

const parsingListOfTestItems = (data, limit = 3) => {
    const count = limit || data?.length
    let listOfTest = []
    data?.forEach((item, index) => {
        if (index < count) {
            listOfTest.push({
                id: item.sku_id,
                skuCategory: item.cart_category || "",
                image: {
                    imageUrl: item.image?.url,
                    altText: item.image?.alt,
                },
                header: item.header,
                productType: null,
                discountPercent: item.prices?.discount,
                discountedPrice: item.prices?.discounted_price,
                price: item.prices?.mrp || "",
                description: item?.info,
                icon: {
                    iconUrl: item.delete_icon?.url,
                    altText: item.delete_icon?.alt,
                },
                tag: {
                    label: item.tag?.text,
                    borderColor: item.tag?.border_color,
                    color: item?.tag?.text_color,
                    backgroundColor: item.tag?.bg_color,
                },
                priceText: item.final_price || "",
                subText: item?.patient_count,
                url: item?.url,
                isAvailable: item?.is_available,
                informationDetails: item?.patients_data?.display_text,
                patientDetails: {
                    header: item.patients_data?.details?.header,
                    description: item.patients_data?.details?.description,
                    confirmCta: item.patients_data?.details?.confirm_cta?.text,
                },
                mixPanelData: item.mix_panel_data,
            })
        }
    })
    return listOfTest
}

const parseHiddenListOfTestItems = (data, limit) => {
    let hiddenListOfTest = []
    data?.forEach((item, index) => {
        if (index >= limit) {
            hiddenListOfTest.push({
                id: item?.sku_id,
                skuCategory: item.cart_category || "",
                image: {
                    imageUrl: item.image?.url,
                    altText: item.image?.alt,
                },
                header: item.header,
                productType: null,
                discountPercent: item.prices?.discount,
                discountedPrice: item.prices?.discounted_price,
                price: item.prices?.mrp || "",
                description: item?.info,
                icon: {
                    iconUrl: item.delete_icon?.url,
                    altText: item.delete_icon?.alt,
                },
                tag: {
                    label: item.tag?.text,
                    borderColor: item.tag?.border_color,
                    color: item?.tag?.text_color,
                    backgroundColor: item.tag?.bg_color,
                },
                priceText: null,
                subText: null,
                url: item?.url,
                isAvailable: item?.is_available,
                informationDetails: item?.patients_data?.display_text,
                patientDetails: {
                    header: item.patients_data?.details?.header,
                    description: item.patients_data?.details?.description,
                    confirmCta: item.patients_data?.details?.confirm_cta?.text,
                },
            })
        }
    })
    return hiddenListOfTest
}

const parseBottomSheetData = (widgets) => {
    let labDetailsBottomSheetData = {}
    widgets?.length > 0 &&
        widgets.forEach((item) => {
            switch (item?.type) {
                case "basic_details": {
                    labDetailsBottomSheetData.labTestDescriptionProps = {
                        type: item?.type,
                        title: item?.data?.title,
                        image: {
                            url: item?.data?.image?.url,
                            altText: item?.data?.image?.alt,
                        },
                    }
                    break
                }
                case "rating_widget": {
                    labDetailsBottomSheetData.ratingsOverviewProps = {
                        type: item?.type,
                        bookinCountImageUrl: item?.data?.booking_count_image?.url,
                        bookinCountImageAlt: item?.data?.booking_count_image?.alt,
                        bestSellerTag: item?.data?.best_seller?.tag,
                        bestSellerText: item?.data?.best_seller?.display_text,
                        etaImageUrl: item?.data?.eta?.image?.url,
                        etaImageAlt: item?.data?.eta?.image?.alt,
                        etaImageText: item?.data?.eta?.display_text,
                        socialCueIcon: item?.data?.social_cue?.icon,
                        socialCueText: item?.data?.social_cue?.display_text,
                        bookingCount: item?.data?.booking_count,
                        overviewValue: item?.data?.overview?.value,
                        overviewOutOf: item?.data?.overview?.outOf,
                        ratingCount: item?.data?.overview?.rating_count,
                        reviewCount: item?.data?.overview?.review_count,
                        overviewText: item?.data?.overview?.display_text,
                        etaTextData: item?.data?.certificate?.header
                            ? {
                                  text: item?.data?.certificate?.header,
                                  imageUrl: item?.data?.certificate?.image?.url,
                                  imageAltText: item?.data?.certificate?.image?.alt,
                              }
                            : null,
                    }
                    break
                }
                case "general_description": {
                    labDetailsBottomSheetData.generalDescriptionProps = {
                        type: item?.type,
                        header: item?.data?.header,
                        content: item?.data?.display_text,
                    }
                    break
                }
            }
        })
    return labDetailsBottomSheetData
}

export const parseInsuranceApplicantDetailsForm = (data) => {
    if (!data) return {}
    return {
        mixPanelData: data?.mix_panel_data,
        headerImage: {
            url: data?.header_image?.url,
            alt: data?.header_image?.alt,
            resolution: data?.header_image?.resolution,
        },
        header: data?.header,
        subHeader: data?.sub_header,
        fields: data?.fields?.map((field) => ({
            name: field?.name === "mobile_number" ? "phone" : field?.name,
            label: field?.label,
            required: field?.required,
            inputType: field?.input_type,
            errorMessage: field?.empty_error_message,
            inputOptions:
                field?.input_options?.map((option) => ({
                    label: option,
                    value: option,
                })) || [],
            value: field?.value || "",
        })),
        primaryCta: {
            action: data?.primary_cta?.action,
            text: data?.primary_cta?.text,
            mixPanelData: data?.primary_cta?.mix_panel_data,
            functionMap: data?.primary_cta?.function_map,
        },
        secondaryCta: {
            text: data?.secondary_cta?.text,
            mixPanelData: data?.secondary_cta?.mix_panel_data,
            functionMap: data?.secondary_cta?.function_map,
        },
    }
}
export const parseInsuranceValidationFailedDialogData = (data) => {
    if (!data) return {}
    return {
        header: data?.header,
        description: data?.description,
        primaryCta: {
            text: data?.primary_cta?.text,
            action: data?.primary_cta?.action,
            redirectUrl: data?.primary_cta?.details?.redirect_url,
        },
    }
}

export { parseWidgetsData, parseFunnelSaleCompleteEventData }
